

























import { Component, Vue } from "vue-property-decorator"
import LayoutSubmissionView from "@/components/layouts/LayoutSubmissionView.vue"
import LayoutNavbarHorizontal from "@/components/layouts/LayoutNavbarHorizontal.vue"
import LayoutNavbarHorizontalItem from "@/components/layouts/LayoutNavbarHorizontalItem.vue"
import { TemplateSubmission } from "@/model/interfaces/submission/templateSubmission/templateSubmission"
import TemplateSubmissionModule from "@/store/modules/submission/TemplateSubmissionModule"
import SecurityModule from "@/store/modules/SecurityModule"
import Combobox from "@/components/inputs/Combobox.vue"
import { canViewItems } from "@/model/enum/submission/templateSubmission/canViewEnum"

@Component({
  components: {
    Combobox,
    LayoutNavbarHorizontal,
    LayoutNavbarHorizontalItem,
    LayoutSubmissionView
  }
})
export default class ReportDataPublicationView extends Vue {
  viewItems = canViewItems

  get viewSelected(): string {
    return TemplateSubmissionModule.canViewSelected
  }

  set viewSelected(value: string) {
    TemplateSubmissionModule.setViewSelected(value)
  }

  get submission(): TemplateSubmission | null {
    return TemplateSubmissionModule.currentSubmission
  }

  get isFocalPoint(): boolean {
    return SecurityModule.isFocalPoint
  }
}
